import React from "react";
import { useApiAction, ErrorMessage } from "@redriver/cinnamon";
import { requestSsoLogin } from "./actions";

const AzureSsoSignIn = ({ code, codeVerifier }) => {
  const [{ success, error, busy }] = useApiAction(requestSsoLogin, {
    lazy: false,
    actionParams: { code, codeVerifier },
  });

  if (!busy && !success) {
    return <ErrorMessage header="Sign In Error" error={error} omitCodes />;
  }

  // if successful, the user will be redirected momentarily
  return null;
};

export default AzureSsoSignIn;
